import {Subject} from "rxjs";

const alert = new Subject();
export const alertService={

    sendMessage: (message,type,status) => alert.next({ message: message,type:type,status:status}),
    clearMessages: () => alert.next(),
    getMessage: () => alert.asObservable()
}